// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as SalesRoutes from "./SalesRoutes.res.js";
import * as SalesListPage from "./SalesListPage.res.js";
import * as AccessDeniedPage from "../Error/AccessDeniedPage.res.js";
import * as SalesDetailsPage from "./SalesDetailsPage.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function SalesRouter(props) {
  let subUrlPath = props.subUrlPath;
  let userRole = Auth.useRole();
  if (!Auth.isAuthorizedAccess(userRole, SalesRoutes.baseRoute)) {
    return JsxRuntime.jsx(AccessDeniedPage.make, {});
  }
  if (subUrlPath === 0) {
    return JsxRuntime.jsx(SalesListPage.make, {});
  }
  switch (subUrlPath.hd) {
    case "credit-note" :
      let match = subUrlPath.tl;
      if (match !== 0 && match.tl === 0) {
        return JsxRuntime.jsx(SalesDetailsPage.make, {
          saleType: "CreditNote",
          id: match.hd
        });
      }
      break;
    case "delivery-note" :
      let match$1 = subUrlPath.tl;
      if (match$1 !== 0 && match$1.tl === 0) {
        return JsxRuntime.jsx(SalesDetailsPage.make, {
          saleType: "DeliveryNote",
          id: match$1.hd
        });
      }
      break;
    case "invoice" :
      let match$2 = subUrlPath.tl;
      if (match$2 !== 0 && match$2.tl === 0) {
        return JsxRuntime.jsx(SalesDetailsPage.make, {
          saleType: "Invoice",
          id: match$2.hd
        });
      }
      break;
    case "quote" :
      let match$3 = subUrlPath.tl;
      if (match$3 !== 0 && match$3.tl === 0) {
        return JsxRuntime.jsx(SalesDetailsPage.make, {
          saleType: "Quote",
          id: match$3.hd
        });
      }
      break;
    case "receipt" :
      let match$4 = subUrlPath.tl;
      if (match$4 !== 0 && match$4.tl === 0) {
        return JsxRuntime.jsx(SalesDetailsPage.make, {
          saleType: "SalesReceipt",
          id: match$4.hd
        });
      }
      break;
    case "refund-receipt" :
      let match$5 = subUrlPath.tl;
      if (match$5 !== 0 && match$5.tl === 0) {
        return JsxRuntime.jsx(SalesDetailsPage.make, {
          saleType: "RefundReceipt",
          id: match$5.hd
        });
      }
      break;
  }
  return JsxRuntime.jsx(Navigation.Redirect.make, {
    route: SalesRoutes.baseRoute
  });
}

let make = SalesRouter;

export {
  make,
}
/* Auth Not a pure module */
